export default __webpack_public_path__ + "static/media/exemplo.3dbcde0e.csv";